var webSocketMixin = {
    data: function () {
        return {
            websocket: null,
            socketOrderId: null,
            socketResponseHandler: function () {
                console.warn('response handler not setup');
            }
        };
    },
    methods: {
        setSocket: function (_a) {
            var websocket = _a.websocket, orderId = _a.orderId, responseHandler = _a.responseHandler;
            this.websocket = websocket;
            this.socketOrderId = orderId;
            this.socketResponseHandler = responseHandler;
            websocket.onopen = this.socketOnOpen;
            websocket.onclose = this.socketOnClose;
            websocket.onmessage = this.socketOnMessage;
            websocket.onerror = this.socketOnError;
        },
        socketPing: function (event) {
            var data = event.data;
            var start = data.indexOf(":");
            var end = data.indexOf("{");
            var payload = data.substring(start + 1, end - 1);
            var ack = "ACK:" + payload;
            this.socketSend(ack);
            var response = JSON.parse(data.substring(end));
            this.socketResponseHandler(response);
        },
        socketSend: function (message) {
            var websocket = this.websocket;
            if (!websocket) {
                console.warn('websocket data property was null');
            }
            websocket.send(message);
        },
        socketOnOpen: function (event) {
            var orderId = this.socketOrderId;
            var payload = "ois-" + orderId;
            try {
                this.socketSend(payload);
            }
            catch (err) {
                console.log(err);
            }
        },
        socketOnClose: function (event) {
            console.log("socket closed: " + event);
        },
        socketOnMessage: function (event) {
            var data = event.data;
            var dataIsJSON = (data.indexOf("JSON:") === 0);
            if (dataIsJSON) {
                this.socketPing(event);
            }
            else {
                console.log("connection will close");
            }
        },
        socketOnError: function (event) {
            console.error("socket error: " + event);
        },
        closeSocket: function () {
            this.websocket.close();
            this.websocket = null;
        },
    },
};
export default webSocketMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/webSocketMixin.ts
// module id = 0p0u
// module chunks = 18